const BaseView = require('components-framework/view/base.view');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const UIStrategy = require('../ui_strategies/ui_strategy.factory');

module.exports = withCachedSelectors(BaseView.extend({
    selectors: {
        baggageOptionsList: '.baggage_options_list',
    },

    initialize(options) {
        this.ancillaryContainer = options.ancillaryContainer;
        this.primeInfo = options.primeInfo;
        this.uiStrategy = UIStrategy.factory(this.$el, this.ancillaryContainer, this.templates,
            this.keys, this.primeInfo);
        this.render();
    },

    render() {
        const wrapperData = this.uiStrategy.getWrapperData();

        this.$el.html(this.templates.main({
            wrapper: this.uiStrategy.templates.wrapper(wrapperData),
        }));
    },

    update(data, parent) {
        const listData = this.uiStrategy.getSelectorData(data);

        this.parent = parent;
        this.$el.find(this.selectors.baggageOptionsList)
            .html(this.uiStrategy.templates.list(listData));
    },

    toggle(hide) {
        this.uiStrategy.toggle(this.parent, hide);
    },

    close() {
        this.toggle(true);
    },

    open() {
        this.toggle(false);
    },

    onSelectBaggage(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        const selectedBagData = this.uiStrategy.getSelectedBaggageData(evt);
        const isValidData = selectedBagData
            && typeof selectedBagData === 'object'
            && selectedBagData.bag;

        if (isValidData) {
            const optionCid = selectedBagData.bag;
            this.parent.changeSelection.call(this.parent, optionCid);

            this.close();
        }
    },

    onBaggageRemove(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        this.parent.onBaggageRemove.call(this.parent, evt);
        this.close();
    },

    onClose(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.parent.onCloseSelector.call(this.parent);
        this.close();
    },
}));
